import { render } from "./StatusCadastroSelect.vue?vue&type=template&id=6f8f9b71"
import script from "./StatusCadastroSelect.vue?vue&type=script&lang=js"
export * from "./StatusCadastroSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__